import { render, staticRenderFns } from "./sharevIndex.vue?vue&type=template&id=0157f9c2&scoped=true&"
import script from "./sharevIndex.vue?vue&type=script&lang=js&"
export * from "./sharevIndex.vue?vue&type=script&lang=js&"
import style0 from "./sharevIndex.vue?vue&type=style&index=0&id=0157f9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157f9c2",
  null
  
)

export default component.exports